import React from 'react';
import PropTypes from 'prop-types';

import Divider from 'components/Divider';
import useUniqueId from 'hooks/useUniqueId';

import Panel from 'components/Panel';
import Heading from 'components/Heading';

const DividerPanel = ({id, header, children}) => {
	const uniqueId = useUniqueId(id);

	return (
		<>
			<Divider />
			<Panel aria-labelledby={uniqueId}>
				<Heading as="h2" mb="m" id={uniqueId} size="small">
					{header}
				</Heading>
				{children}
			</Panel>
			<Divider mb="l" />
		</>
	);
};

export default DividerPanel;

DividerPanel.propTypes = {
	header: PropTypes.string.isRequired,
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
